module.exports = __webpack_public_path__ + "static/logo_icon-74c4056bb67a33879aa0a5a8d2631216.png";